import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Shows one delivery method when admixtures is selected in order creation
 */
@Injectable()
export class ShowOneDeliveryMethodForAdmixturesFeature implements IFlagFeature {
  name = Features.SHOW_ONE_DELIVERY_METHOD_FOR_ADMIXTURES;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
